import React, { useEffect, useState } from "react";
//import { Link } from 'react-router-dom'
import { createRole } from "../../../../src/service/userRoleApiServices";
//import { Link } from "react-router-dom";
import Select from "react-select";
import { getModules } from "../../../service/userRoleApiServices";
import permissionsData from '../../../permission.json';
import Swal from "sweetalert2";
import { Table, Checkbox } from "antd";
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import PropTypes from "prop-types";
const AddRole = ({handlereload}) => {
    const [modules, setModules] = useState([]);
    const [roleName, setRoleName] = useState("");
    const [functions, setFunctionList] = useState([]);
    const [modulesList, setModulesList] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [filteredModules, setFilteredModules] = useState([]);
    const [data, setData] = useState([]);
    const [selectedFunctions, setSelectedFunctions] = useState([]);
    const [selectedModules, setSelectedModules] = useState([]);
    useEffect(() => {
        getModules().then(value => {
            console.log("Response", value)
            setModulesList(value);
            let map = value.map(module => {
                return {
                    label: module.label,
                    value: module._id
                };
            });
            setModules(map);

        })
    }, []);

    {


        /*
        const handleGetRoles = async () => {
          try {
            const rolesData = await getRoles();
            setRoles(rolesData);
          } catch (error) {
            console.error("Error fetching roles:", error);
          }
        };
        console.log(roles, "Updated Roles addrole.jsx");
      */
    }

    // const handlePermissions = (event) => {
    //   const { value, checked } = event.target;
    //   if (checked) {
    //     setPermissions([...permissions, value]);
    //   } else {
    //     setPermissions(permissions.filter((permission) => permission !== value));
    //   }
    // };
    //
    // const handleCreateRole = async () => {
    //   try {
    //     const response = await createRole(roleName, functionName, permissions);
    //     console.log("Role created:", response);
    //     setRoleName("");
    //     setFunctionName("");
    //     setPermissions([]);
    //   } catch (error) {
    //     console.error("Error creating role:", error);
    //   }
    // };
    const customStyles = {
        // Multi-value (selected tag) style
        multiValue: (styles) => {
            return {
                ...styles,
                backgroundColor: '#ff7f00', // Background color of the selected tag
                borderRadius: '12px', // Rounded corners
                color: 'white', // Text color
            };
        },
        // Multi-value label (text inside the tag) style
        multiValueLabel: (styles) => ({
            ...styles,
            color: 'white', // Text color of the selected option
        }),
        // Multi-value remove (the "x" button inside the tag) style
        multiValueRemove: (styles) => ({
            ...styles,
            color: 'white', // Color of the "x" icon
            ':hover': {
                backgroundColor: '#ff7f00', // Darker color on hover
                color: 'white',
            },
        }),
    };
    const handleChangeModule = (val) => {
        setFunctionList([])
        setFilteredModules([])
        setSelectedModules(val)
        console.log("Selected Module", val)
        console.log("modulesList", modulesList)
        val.forEach(a => {
            let filtered = modulesList.find(value1 => value1._id === a.value);
            console.log("Filtered Module", filtered, filteredModules)
            setFilteredModules(filtered);
            filtered.functions.forEach(value => {
                const function1 = {
                    module: filtered._id,
                    function: value
                }
                setFunctionList(prevModules => [
                    ...prevModules,  // Spread the previous modules array
                    function1       // Add the new object
                ]);
            })

        })


    };
    // const handleCheckboxChange = (functionId, permissionType, isChecked, module) => {
    //     const permission = { function: functionId, permission: permissionType, moduleId: module };
    // console.log(permission,"Helpless")
    // const obj={
    //     moduleId:module,
    //     functions:[{functionId:functionId,permissionType:true}]
    // }
    //     if (isChecked) {
    //         // Add to the array if checked
    //         setSelectedPermissions((prevState) => [...prevState, permission]);
    //     } else {
    //         // Remove from the array if unchecked
    //         setSelectedPermissions((prevState) =>
    //             prevState.filter(
    //                 (item) => item.function !== functionId || item.permission !== permissionType
    //             )
    //         );
    //     }
    // };
    const handleCheckboxChange = (functionId, permissionType, isChecked, module) => {
        const permission = { function: functionId, permission: permissionType, moduleId: module };
        console.log(permission, "Helpless");

        // Create the permissions object dynamically
        const permissionsObject = permissionsData.permissions.reduce((acc, perm) => {
            acc[perm.key] = perm.key === permissionType ? isChecked : false;
            return acc;
        }, {});

        // Construct the object for the current change
        const obj = {
            moduleId: module,
            functions: [{ functionId: functionId, permissions: permissionsObject }],
        };

        if (isChecked) {
            // Add to `selectedPermissions`
            setSelectedPermissions((prevState) => [...prevState, permission]);

            // Add or update `obj` in `data`
            setData((prevData) => {
                const moduleExists = prevData.find((item) => item.moduleId === module);

                if (moduleExists) {
                    // Module exists, check if the function exists
                    const functionExists = moduleExists.functions.find(
                        (func) => func.functionId === functionId
                    );

                    if (functionExists) {
                        // Function exists, update its permission
                        return prevData.map((item) =>
                            item.moduleId === module
                                ? {
                                    ...item,
                                    functions: item.functions.map((func) =>
                                        func.functionId === functionId
                                            ? {
                                                ...func,
                                                permissions: {
                                                    ...func.permissions,
                                                    [permissionType]: isChecked, // Update only the current permission type
                                                },
                                            }
                                            : func
                                    ),
                                }
                                : item
                        );
                    } else {
                        // Function does not exist, add it to the functions array
                        return prevData.map((item) =>
                            item.moduleId === module
                                ? {
                                    ...item,
                                    functions: [...item.functions, { functionId, permissions: permissionsObject }],
                                }
                                : item
                        );
                    }
                } else {
                    // Module does not exist, add a new entry
                    return [...prevData, obj];
                }
            });
        } else {
            // Remove from `selectedPermissions`
            setSelectedPermissions((prevState) =>
                prevState.filter(
                    (item) => item.function !== functionId || item.permission !== permissionType
                )
            );

            // Remove the function from `data`
            setData((prevData) => {
                return prevData
                    .map((item) =>
                        item.moduleId === module
                            ? {
                                ...item,
                                functions: item.functions.map((func) => {
                                    if (func.functionId === functionId) {
                                        return {
                                            ...func,
                                            permissions: {
                                                ...func.permissions,
                                                [permissionType]: false, // Set the permission type to false
                                            },
                                        };
                                    }
                                    return func;
                                }),
                            }
                            : item
                    )
                    .filter((item) => item.functions.some((func) => Object.values(func.permissions).includes(true))); // Keep only modules with valid permissions
            });
        }
    };

    // const handleCheckNestedboxChange = (subrecordId, functionId, permissionType, isChecked, module) => {
    //     const permissionsObject = permissionsData.permissions.reduce((acc, perm) => {
    //         acc[perm.key] = perm.key === permissionType ? isChecked : false;
    //         return acc;
    //     }, {});

    //     const permission = {
    //         subrecordId,
    //         function: functionId,
    //         permission: permissionType,
    //         moduleId: module,
    //         isChecked
    //     };
    //     if (isChecked) {
    //         // Add to `selectedPermissions`
    //         setSelectedPermissions((prevState) => [...prevState, permission]);
    //     } else {
    //         setSelectedPermissions((prevState) =>
    //             prevState.filter(
    //                 (item) => item.function !== functionId || item.permission !== permissionType || item.subrecordId !== subrecordId
    //             ))
    //     }
    //     setData((prevData) => {
    //         const moduleExists = prevData.find((item) => item.moduleId === module);

    //         if (moduleExists) {
    //             // Module exists, check if the function exists
    //             const functionExists = moduleExists.functions.find((func) => func.functionId === functionId);

    //             if (functionExists) {
    //                 // Function exists, check if subFunction exists, if not, add a new one
    //                 return prevData.map((item) =>
    //                     item.moduleId === module
    //                         ? {
    //                             ...item,
    //                             functions: item.functions.map((func) =>
    //                                 func.functionId === functionId
    //                                     ? {
    //                                         ...func,
    //                                         subFunctions: func.subFunctions.some((subFunc) => subFunc.functionId === subrecordId)
    //                                             ? func.subFunctions.map((subFunc) =>
    //                                                 subFunc.functionId === subrecordId
    //                                                     ? {
    //                                                         ...subFunc,
    //                                                         permissions: {
    //                                                             ...subFunc.permissions,
    //                                                             [permissionType]: isChecked, // Update the specific permission type
    //                                                         },
    //                                                     }
    //                                                     : subFunc
    //                                             )
                                                
    //                                             : [
    //                                                 ...func.subFunctions,
    //                                                 { functionId: subrecordId, permissions: permissionsObject },
    //                                             ], // Add new subFunction if not found
    //                                     }
    //                                     : func
    //                             ),
    //                         }
    //                         : item
    //                 );
    //             } else {
    //                 // Function does not exist, add it to the functions array
    //                 return prevData.map((item) =>
    //                     item.moduleId === module
    //                         ? {
    //                             ...item,
    //                             functions: [
    //                                 ...item.functions,
    //                                 { functionId, subFunctions: [{ functionId: subrecordId, permissions: permissionsObject }] },
    //                             ],
    //                         }
    //                         : item
    //                 );
    //             }
    //         } else {
    //             // Module does not exist, add a new module with function and subFunction
    //             const newObj = {
    //                 moduleId: module,
    //                 functions: [
    //                     {
    //                         functionId,
    //                         subFunctions: [{ functionId: subrecordId, permissions: permissionsObject }],
    //                     },
    //                 ],
    //             };
    //             return [...prevData, newObj];
    //         }
    //     });
    // };
    const handleCheckNestedboxChange = (subrecordId, functionId, permissionType, isChecked, module) => {
        const permissionsObject = permissionsData.permissions.reduce((acc, perm) => {
            acc[perm.key] = perm.key === permissionType ? isChecked : false;
            return acc;
        }, {});
    
        const permission = {
            subrecordId,
            function: functionId,
            permission: permissionType,
            moduleId: module,
            isChecked
        };
    
        setSelectedPermissions((prevState) =>
            isChecked
                ? [...prevState, permission]
                : prevState.filter(
                      (item) =>
                          item.function !== functionId ||
                          item.permission !== permissionType ||
                          item.subrecordId !== subrecordId
                  )
        );
    
        setData((prevData) => {
            const moduleExists = prevData.some((item) => item.moduleId === module);
        
            if (moduleExists) {
                return prevData.map((item) => {
                    if (item.moduleId === module) {
                        const functionExists = item.functions.some((func) => func.functionId === functionId);
        
                        if (functionExists) {
                            return {
                                ...item,
                                functions: item.functions.map((func) => {
                                    if (func.functionId === functionId) {
                                        const updatedSubFunctions = (func.subFunctions || []).some(
                                            (subFunc) => subFunc.functionId === subrecordId
                                        )
                                            ? (func.subFunctions || [])
                                                  .map((subFunc) =>
                                                      subFunc.functionId === subrecordId
                                                          ? {
                                                                ...subFunc,
                                                                permissions: {
                                                                    ...subFunc.permissions,
                                                                    [permissionType]: isChecked,
                                                                },
                                                            }
                                                          : subFunc
                                                  )
                                                  .filter((subFunc) =>
                                                      Object.values(subFunc.permissions || {}).some((value) => value)
                                                  )
                                            : [
                                                  ...func.subFunctions,
                                                  { functionId: subrecordId, permissions: permissionsObject },
                                              ];
        
                                        return {
                                            ...func,
                                            subFunctions: updatedSubFunctions.length > 0 ? updatedSubFunctions : [],
                                        };
                                    }
                                    return func;
                                }) .filter(
                                        (func) =>
                                            (func.subFunctions && func.subFunctions.length > 0) ||
                                        (!func.subFunctions && Object.values(func.permissions || {}).some((value) => value))
                                    ), // Ensure subFunctions exists
                            };
                        } else {
                            return {
                                ...item,
                                functions: [
                                    ...item.functions,
                                    { functionId, subFunctions: [{ functionId: subrecordId, permissions: permissionsObject }] },
                                ],
                            };
                        }
                    }
                    return item;
                }).filter((item) => item.functions.some((func) => (func.subFunctions && func.subFunctions.length > 0) ||
                (!func.subFunctions && Object.values(func.permissions || {}).some((value) => value)))); // Ensure functions array is not empty
            } else {
                return [
                    ...prevData,
                    {
                        moduleId: module,
                        functions: [
                            {
                                functionId,
                                subFunctions: [{ functionId: subrecordId, permissions: permissionsObject }],
                            },
                        ],
                    },
                ];
            }
        });
        
    };
    
    const isChecked = (functionId, permissionType) => {
        return selectedPermissions.some(
            (item) => item.function === functionId && item.permission === permissionType
        );
    };
    const isCheckedSub = (subRecordId, functionId, permissionType) => {
        return selectedPermissions.some(
            (item) => item.function === functionId && item.permission === permissionType && item.subrecordId === subRecordId
        );
    };
    const showSuccess = (msg, type, title) => {
        return Swal.fire({
            title: title,
            text: msg,
            icon: type
        });
    }
    console.log("selectedPermissions", selectedPermissions, "Functions", functions)
    const submitRole = async() => {

        if (!roleName || filteredModules.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "Please fill in all the required fields to create."
            });
            return;
        }

        if (data.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "Please select permissions for the role."
            });
            return;
        }
        const filteredData = data.filter(item => item.functions.length > 0); // Remove objects with empty functions array

        if (filteredData.length === 0) {
            Swal.fire({
                icon: "warning",
                text: "Please select permissions for the role."
            });
            return;
        }
    
       await  createRole({
            roleName: roleName,
            modules: filteredData

        }).then(value => {
            showSuccess(value.msg, "success", "success")
        })
        handleReset()
        handlereload()


    };

    // const expandedRowRender = (record) => {
    //     // Define columns for subFunctions
    //     const subFunctionColumns = [
    //         {
    //             title: 'Sub-Function',
    //             dataIndex: 'label',
    //             key: 'label',
    //             render: (label) => <span>{label}</span>,
    //         },
    //         ...permissionsData.permissions.map((perm) => ({
    //             title: perm.label,
    //             dataIndex: perm.key,
    //             key: perm.key,
    //             render: (text, subRecord) => (
    //                 <Checkbox
    //                     checked={isChecked(subRecord._id, perm.key)} // Dynamically check state for subFunctions
    //                     onChange={(e) =>
    //                         handleCheckboxChange(subRecord._id, perm.key, e.target.checked, record.module)
    //                     }
    //                 />
    //             ),
    //         })),
    //     ];

    //     return (
    //         <Table
    //             columns={subFunctionColumns}
    //             dataSource={record.function.subFunctions} // Pass subFunctions as dataSource
    //             pagination={false} // Disable pagination for nested table
    //             rowKey={(subFunc) => subFunc._id} // Unique key for sub-functions
    //         />
    //     );
    // };
    const columns = [
        {
            title: 'Function',
            dataIndex: 'function',
            key: 'function',
            render: (func) => <span>{func.label}</span>, // Accessing the label directly
        },
        {
            title: 'Enable',
            key: 'enable',
            render: (text, record) => (
                <Checkbox
                    checked={isCheckedEnable(record.function._id)} // Dynamically check state for Enable checkbox
                    onChange={(e) =>
                        handleEnableCheckboxChange(record.function._id, e.target.checked) // Handle Enable checkbox change
                    }
                />
            ),
        },
        ...permissionsData.permissions.map((perm) => ({
            title: perm.label,
            dataIndex: perm.key,
            key: perm.key,
            render: (text, record) => (
                record.function.subFunctions.length === 0 && (
                    <Checkbox
                        disabled={!isCheckedEnable(record.function._id)}
                        checked={isChecked(record.function._id, perm.key)} // Dynamically check state
                        onChange={(e) =>
                            handleCheckboxChange(record.function._id, perm.key, e.target.checked, record.module)
                        }
                    />
                ))
        })),
    ];
    const isCheckedEnable = (functionId) => {
        // Check in the state or data if the function is enabled
        return selectedFunctions.some((item) => item.functionId === functionId && item.isEnabled);
    };

    // Function to handle changes in the "Enable" checkbox
    const handleEnableCheckboxChange = (functionId, isChecked) => {
        setSelectedFunctions((prevState) => {
            // Update the state to reflect the change for the specific function
            const updatedFunctions = prevState.map((item) =>
                item.functionId === functionId ? { ...item, isEnabled: isChecked } : item
            );
            // If the function doesn't exist in the state, add it
            if (!updatedFunctions.some((item) => item.functionId === functionId)) {
                updatedFunctions.push({ functionId, isEnabled: isChecked });
            }
            return updatedFunctions;
        });
    };
    // Prepare data for Ant Design Table
const handleReset=()=>{
    setRoleName("")
    setData([])
    setSelectedModules([])
    setFunctionList([])
    setSelectedPermissions([])
    setFilteredModules([])
    setSelectedFunctions([])
}
    console.log(data, "DTATFYFYTFYT")

    return (
        <div >
            {/* Add Role */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog modal-lg modal-dialog-centered custom-modal-two" style={{ maxWidth: '80%' }}>
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-body custom-modal-body">
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="card-title">Create Role</h5>
                                        </div>
                                        <div className="card-body">
                                            <form action="#">
                                                <div className="mb-3">
                                                    <label className="form-label">Role Name</label>
                                                    <input type="text" className="form-control" value={roleName} onChange={(e) => setRoleName(e.target.value)} />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Select Modules</label>
                                                    <Select
                                                        options={modules}
                                                        className="select2"
                                                        isMulti={true}
                                                        styles={customStyles}
                                                        value={selectedModules}
                                                        onChange={handleChangeModule}
                                                    // defaultValue={[multiselect[0]]}
                                                    />
                                                </div>

                                                <div className="mb-4">

                                                    <div className="table-responsive mt-4">
                                                        <Table
                                                            dataSource={functions}
                                                            columns={columns}
                                                            pagination={false}
                                                            expandable={{
                                                                expandedRowRender: (record) => {
                                                                    if (record.function.subFunctions && record.function.subFunctions.length > 0) {
                                                                        // Render the expanded row logic for rows with sub-functions
                                                                        return (
                                                                            <Table
                                                                                columns={[
                                                                                    {
                                                                                        title: 'Sub-Function',
                                                                                        dataIndex: 'label',
                                                                                        key: 'label',
                                                                                        render: (label) => <span>{label}</span>,
                                                                                    },
                                                                                    ...permissionsData.permissions.map((perm) => ({
                                                                                        title: perm.label,
                                                                                        dataIndex: perm.key,
                                                                                        key: perm.key,
                                                                                        render: (text, subRecord) => (
                                                                                            <Checkbox
                                                                                                disabled={!isCheckedEnable(record.function._id)}
                                                                                                checked={isCheckedSub(subRecord._id, record.function._id, perm.key)}
                                                                                                onChange={(e) =>
                                                                                                    handleCheckNestedboxChange(subRecord._id, record.function._id, perm.key, e.target.checked, record.module)
                                                                                                }
                                                                                            />
                                                                                        ),
                                                                                    })),
                                                                                ]}
                                                                                dataSource={record.function.subFunctions}
                                                                                pagination={false}
                                                                                rowKey={(subFunc) => subFunc._id}
                                                                                bordered
                                                                            />
                                                                        );
                                                                    }
                                                                    return null; // No expandable content if there are no sub-functions
                                                                },
                                                                expandIcon: ({ expanded, onExpand, record }) => {
                                                                    if (record.function.subFunctions && record.function.subFunctions.length > 0) {
                                                                        return (
                                                                            <span
                                                                                onClick={(e) => onExpand(record, e)}
                                                                                style={{ cursor: 'pointer' }}
                                                                            >
                                                                                {expanded ? <UpOutlined /> : <DownOutlined />}
                                                                            </span>
                                                                        );
                                                                    }
                                                                    return null; // No icon if no sub-functions
                                                                },
                                                            }}
                                                            bordered
                                                            rowKey={(record) => record.function._id}
                                                        />
                                                    </div>
                                                </div>

                                                {/* <div className="text-end">
                                                    <Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={submitRole}>
                                                        Submit
                                                    </Link>
                                                </div> */}

                                                <div style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            

                                        }} className="mt-5">
                                            <button
                                                type="button"
                                                className="btn btn-cancel"
                                                data-bs-dismiss="modal"
                                                //onClick={print}
                                                onClick={handleReset}
                                            >
                                            Cancel
                                            </button>
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-reset me-2"
                                                    onClick={handleReset}
                                                    
                                                >
                                                    Reset
                                                </button>
                                                
                                                {(data.length===0
                                                ) ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-submit"
                                                        onClick={submitRole}
                                                    >
                                                        Save
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-submit"
                                                        onClick={submitRole}
                                                        data-bs-dismiss="modal"
                                                    >
                                                        Save
                                                    </button>
                                                )}

                                            </div>
                                        </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Role */}
        </div>
    );
};
AddRole.propTypes = {
    handlereload: PropTypes.func.isRequired,
};
export default AddRole;
